<template>
	<div id="settings-mini-app">
		<router-view />
	</div>
</template>

<script>
import Vue from 'vue';
import store from '@/store';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify.js';
import { getSettingsRouter } from '@/router/helpers.js';
const router = getSettingsRouter();

export default {
	name: 'SettingsRouter',
	router,
	props: {
		routeName: { type: String },
	},
	mounted() {
		// on component mount, we create a new instance of a view app, that actually stands alone inside our application.
		// it uses the same store, capabillities,etc... and lets us add another internal router, espacially for that app
		this.settingApp = new Vue({
			store,
			router,
			vuetify,
			render: (h) => h(App),
		}).$mount('#settings-mini-app');

		router.push({ name: this.routeName });
	},
	beforeDestroy() {
		this.settingApp.$destroy();
		this.settingApp = null;
	},
	data() {
		return { settingApp: null };
	},
};
</script>
